import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Modal, Toast } from "antd-mobile";
import { useTranslation } from '@/i18n';
import { useHistory } from "react-router-dom";
import walletImg from "@/assets/images/wallet.png";
import checkboxImg from "@/assets/images/checkbox.png";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import request from "@/utils/request";
import { freeCardList, freeCardBuy, accountBalance } from "@/api";

const FreeCommissionCardMy = () => {
  const t = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [walletInfo, setWalletInfo] = useState({
    balance: 0,
  });
  const [oneCard, setOneCard] = useState({});
  const [isBalanceSufficient, setIsBalanceSufficient] = useState(false);
  const isDateExpired = (startDate, endDate) => {
    const currentDate = new Date();
    const compareDate = endDate ? new Date(endDate) : new Date(startDate);
    return (
      compareDate.getFullYear() < currentDate.getFullYear() ||
      (compareDate.getFullYear() === currentDate.getFullYear() &&
        (compareDate.getMonth() < currentDate.getMonth() ||
          (compareDate.getMonth() === currentDate.getMonth() &&
            compareDate.getDate() < currentDate.getDate())))
    );
  };
  let token = getLocationSearch().token;
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const [visible, setVisible] = useState(false);
  const pay = async () => {
    Toast.loading(t('freeCard.buyModal.paying'), 0, () => {}, true);
    const res = await request.post(
      `${freeCardBuy}${oneCard.freeCardId}`,
      { token },
      params
    );
    Toast.hide();
    if (res.data.errorCode == 0) {
      Toast.success(t('freeCard.buyModal.paySuccess'));
      setVisible(false);
      getAccountBalance();
      getFreeCardList();
    } else if (res.data.errorMsg) {
      Toast.fail(res.data.errorMsg, 2);
    }
  };
  const toDetail = (item) => () => {
     if (item.status !== 1) {return;}
    history.push(
      `/freeCommissionCardDetail/${item.id}?cardData=${JSON.stringify(
        item
      )}&walletInfo=${JSON.stringify(walletInfo)}`
    );
  };
  const openPay = (e, item) => {
    e.stopPropagation();
    setOneCard(item);
    setIsBalanceSufficient(
      walletInfo.balance >= +(+item.sellPrice * 100).toFixed(0)
    );
    setVisible(true);
  };
  const getFreeCardList = async () => {
    setLoading(true);
    Toast.loading(t('common.loading'), 0, () => {}, true);
    const res = await request.post(freeCardList, { token }, params);
    Toast.hide();
    if (res.data.data) {
      const list = res.data.data||[];
      setList(list.filter((item) => item.buy));
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
    setLoading(false);
  };
  const getAccountBalance = async () => {
    const res = await request.get(accountBalance, { token }, params);
    if (res.data.data) {
      setWalletInfo({
        balance: res.data.data.balance,
      });
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };
  useEffect(() => {
    getFreeCardList();
    getAccountBalance();
    document.title = t('freeCard.title');
  }, []);
  return (
    <div className="free-commission-card">
      {!loading && (
        <>
          <Modal
            visible={visible}
            popup
            closable
            transparent
            onClose={() => setVisible(false)}
            animationType="slide-up"
            title={t('freeCard.buyModal.title')}
          >
            <div className="modal_content">
              <div className="price">
                {oneCard.sellPrice}
                <div className="unit">{t('freeCard.card.yuan')}</div>
              </div>
              <div className="wallet_info">
                <div className="left">
                  <img src={walletImg}></img>{t('freeCard.buyModal.walletPay')}
                  <div className="wallet_info_tips">
                    {t('freeCard.buyModal.walletBalance', { balance: (walletInfo.balance / 100).toFixed(2) })}
                  </div>
                </div>
                <div className="right">
                  <img src={checkboxImg}></img>
                </div>
              </div>
              <div
                className="wallet_info_error_tips"
                style={{ display: isBalanceSufficient ? "none" : "block" }}
              >
                {t('freeCard.buyModal.insufficientBalance')}
              </div>
              <div className="btn_box">
                <Button
                  className="btn"
                  type="warning"
                  onClick={pay}
                  disabled={!isBalanceSufficient}
                >
                  {t('freeCard.buyModal.buyNow')}
                </Button>
              </div>
            </div>
          </Modal>
          <div className="title">{t('freeCard.myTitle')}</div>
          <div className="list">
            {list.length === 0 ? (
              <div className="empty-state">
                {t('freeCard.empty')}
              </div>
            ) : (
              list.map((item, index) => (
                <div
                  className={`card ${isDateExpired(item.freeDate, item.freeEndDate) ? "card_gray_filter" : ""}`}
                  onClick={toDetail(item)}
                  key={item.freeCardId}
                >
                  <div className="tips">
                    <div className="name">{t('freeCard.card.name', { name: item.cardName })}</div>
                  </div>
                  <div className="card_type">
                    <div className="label">{t('freeCard.card.freeDate')}</div>
                    <div className="value">
                      {item.freeEndDate ? `${item.freeDate} ~ ${item.freeEndDate}` : item.freeDate}
                    </div>
                  </div>
                  { isDateExpired(item.freeDate, item.freeEndDate) ? (
                    <div className="status_tag">{t('freeCard.status.ended')}</div>
                  ) : null}
                  <div className="content">
                    <div className="price">{t('freeCard.card.price', { price: item.sellPrice })}</div>
                  </div>
                  <hr />
                  <div className="info">
                    <div className="info_content">{t('freeCard.card.freeTimeSlot', { slot: item.freeTimeSlot })}</div>
                    {/* <div className="right">
                      {item.status === 1 ? (
                        <Button className="btn" type="warning" onClick={(e) => openPay(e, item)} disabled={item.remainderQuantity === 0}>
                          立即购买
                        </Button>
                      ) : item.status === 0 ? (
                        <div className="status-label">待开售</div>
                      ) : item.status === 2 ? (
                        <div className="status-label">已结束</div>
                      ) : item.status === 3 ? (
                        <div className="status-label">已取消</div>
                      ) : null}
                    </div> */}
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default FreeCommissionCardMy;
